import {SVGProps} from "react";

// X logo from the V2 footer (Figma "Icon / x", 78:887).
export const FooterXSvg = ({color = '#F6F4F0', ...props}: SVGProps<SVGSVGElement>) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
        <path
            d="M17.325 1.83325H20.1667L13.9334 8.98325L21.2667 20.1666H15.4917L11 13.3833L5.04169 20.1666H2.10836L8.80002 12.3749L1.65002 1.83325H7.60836L11.7334 8.06659L17.325 1.83325ZM16.3167 18.3333H17.875L6.69169 3.57492H5.04169L16.3167 18.3333Z"
            fill={color}/>
    </svg>
)
